import $ from 'jquery';

function getCurrentPromoIndex(config) {
  let index = parseInt(window.localStorage.getItem(config.url));
  if (isNaN(index)) {
    index = 0;
  }
  window.localStorage.setItem(config.url, index + 1);
  return index % 5;
}

function setPromo(config, index) {
  $('.promo-active-container').hide();
  $(`#promo-active-container-${index}`, config.el).html(
    config.blocks[index]
  ).show();
  $(`#promo-active-container-${index} .carousel`, config.el).carousel();
}

export function loadPromo(config, index) {
  $('.promo-item').removeClass('active');
  $(`.promo-item[data-promo=${index}]`).addClass('active');
  if (config.blocks[index]) {
    $('.promo-active-container').hide();
    $(`#promo-active-container-${index}`).show();
    return;
  }
  $.get(
    config.url,
    {index: index}
  ).then(r => {
    config.blocks[index] = r;
    setPromo(config, index);
  });
}

export default function initPromo(el) {
  let config = {
    blocks: [],
    url: el.data('url'),
    el,
  }
  const index = getCurrentPromoIndex(config);
  const containerEl = $('.promo-active-container', el);
  loadPromo(config, index);
  $('.promo-item', el).on(
    'click',
    e => loadPromo(
      config,
      $(e.target).closest('.promo-item').data('promo')
    )
  );
  $(containerEl).on(
    'click',
    e => {
      if ($(e.target).attr('data-slide-to')) {
        return;
      }
      const url = $(e.target).closest('.promo-active-container').data('url');
      window.location = url;
      return false;
    }
  );

}



// WEBPACK FOOTER //
// ./website/static_media/assets/js/promo.js